// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { GetState } from '@atlassian/react-sweet-state';
import type { State } from './GlobalFieldsTourSteps.types.tsx';

export const maybeWaitForPremiumModal = async (getState: GetState<State>): Promise<void> => {
	// Await the resolution of the deferred promise associated with the premium modal.
	// This ensures that the premium modal has either never been displayed or has already been closed.
	// This mechanism allows for seamless orchestration of all spotlights within a single package,
	// ensuring they are postponed until the premium modal can be displayed and is dismissed.
	// Treat this similar to the `!accountId`, as every loading action
	// in the `onboarding-flow` package should incorporate this check.
	await getState().premium.promise.promise;
};
